import {DceAjaxAction} from "dce-ajax";
import {createDomElementFromString} from "app/lib/utils/createDomElementFromString";

export default class DceAjaxOpenModalAction implements DceAjaxAction {

    execute(data: any): void {
        console.log("OPEN MODAL");
        let modalDiv = createDomElementFromString(data);

        modalDiv.setAttribute('data-open', "1")

        document.body.append(modalDiv);
        //
        // console.log(modalDiv);
        //
        // let ext = (modalDiv as DceHTMLElement).ext
        //
        // console.log("EXT ", ext)
        //
        // if(ext){
        //     let modalExt = ext.getComponent('modal');
        //
        //     if(modalExt){
        //         (modalExt as Modal).open();
        //     }
        // }
    }

    getPriority(): number {
        return 0;
    }

}